// extracted by mini-css-extract-plugin
module.exports = {"title":"no-results_title__c0_xB","subTitle":"no-results_subTitle__jW9in","noResultsLink":"no-results_noResultsLink__5XHxS"};